import type { FirmVocab } from '@/_types/models/firm';

// NOTE @chris this is necessary because block elements cannot be nested
// future solution would be https://www.w3.org/standards/history/css-anchor-position-1/ once it's out of draft
const transformHtmlContent = (htmlContent: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');

  const processNode = (node: Node): string => {
    switch (node.nodeType) {
      case Node.ELEMENT_NODE: {
        const element = node as Element;
        if (element.tagName === 'UL' || element.tagName === 'OL') {
          const listContent = Array.from(element.children)
            .filter((child) => child.tagName === 'LI')
            .map((li) => `<span>${(li as HTMLElement).innerHTML}</span>`)
            .join('');

          return `<span class="glossary-${element.tagName}">${listContent}</span>`;
        }

        if (['A', 'B', 'U'].includes(element.tagName)) {
          return element.outerHTML;
        }

        return Array.from(element.childNodes).map(processNode).join('');
      }

      case Node.TEXT_NODE: {
        return (node as Text).textContent || '';
      }

      default:
        return '';
    }
  };

  const transformedContent = Array.from(doc.body.childNodes)
    .map(processNode)
    .join('');

  return transformedContent;
};

export const getGlossaries = (
  firmVocabs: Array<FirmVocab> = [],
): Record<string, string> | undefined => {
  if (!firmVocabs?.length) return undefined;

  const glossaries: Record<string, string> = firmVocabs?.reduce(
    (acc, firmVocab) => {
      if (firmVocab.key_words) {
        acc[firmVocab.key_words] = transformHtmlContent(firmVocab.description);
      }

      return acc;
    },
    {} as Record<string, string>,
  );

  const sortedGlossaries = Object.fromEntries(
    Object.entries(glossaries).sort((a, b) => b[0].length - a[0].length),
  );

  return sortedGlossaries;
};
